// the backend ends a request after 60s and its history reads and writes add up to about 6s outside
// that limit, so the client only gives up once the backend itself had its say
export const DOCS_CHAT_REQUEST_TIMEOUT_MS = 70 * 1000;

export const DOCS_CHAT_TIMEOUT_STATUS = 408;
